import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { createNlsMiddleware, userstate, lccstate } from '@holmescorp/lcc-state';
import { SlidingPane } from '@holmescorp/base-widgets';
import { subscribe } from '@holmescorp/pub-sub';
import { PathChoice } from '@holmescorp/dashboard-widgets';
import { isEmpty } from 'lodash-es';

interface DashboardProperties {
	onClose?: () => void;
}

const factory = create({
	icache,
	nls: createNlsMiddleware('ditabook'),
	userstate,
	lccstate
}).properties<DashboardProperties>();

export const Dashboard = factory(({ properties, children, middleware: { icache, nls, userstate, lccstate } }) => {
	const { get, path } = userstate;
	const quizPattern = get(path('quizPattern'));
	const { get: lget, path: lpath } = lccstate;
	const quizpatterns = lget(lpath('quizpatterns'));
	// Need to check this too since its a valid but empty quizpattern for the backend
	const emptyQP = { '': '' };
	const hasQP = !isEmpty(quizpatterns) && JSON.stringify(quizpatterns) !== JSON.stringify(emptyQP);

	const { isPlaceholder, messages } = nls();

	if (isPlaceholder) {
		return null;
	}

	const { onClose } = properties();

	const open = icache.getOrSet('open', () => {
		subscribe('open/dashboard', async () => {
			icache.set('open', true);
		});
		return false;
	});

	const vw = window.innerWidth || 0;

	return w(
		SlidingPane,
		{
			key: 'dashboard',
			xqa: 'dashboard-sliding-pane',
			open,
			align: 'right',
			underlay: true,
			title: messages.dashboard_title,
			width: Math.min(vw, 1024),
			onRequestClose: () => {
				icache.set('open', false);
				onClose && onClose();
			}
		},
		[!hasQP || quizPattern ? v('div', {}, children()) : w(PathChoice, {})]
	);
});

export default Dashboard;
